import useTranslation from "@babackapp/translations/use-translation";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@babackapp/ui/components/dialog";
import { Separator } from "@babackapp/ui/components/separator";
import { RejectForm } from "../../../refund/reject-form";
import { useSumbitRejectReturnRequest } from "./use-submit-reject-return-request";
import { LineItemsRejectReasonProvider } from "../../../refund/hooks/use-line-item-reject-reason";
import { useCurrentReturnRequest } from "../../../utils/current-return-request-context";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useInvalidateReturnRequest } from "@babackapp/private-api-client/client/use-invalidate-return-request";

type RejectReturnDialogProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  setLoading: (value: boolean) => void;
};

export default function RejectReturnDialog({
  open,
  setOpen,
  setLoading
}: RejectReturnDialogProps) {
  return (
    <LineItemsRejectReasonProvider>
      <RejectReturnDialogContent open={open} setOpen={setOpen} setLoading={setLoading}/>
    </LineItemsRejectReasonProvider>
  );
}

type RejectReturnDialogContentProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  setLoading: (value: boolean) => void;
};

function RejectReturnDialogContent({
  open,
  setOpen,
  setLoading
}: RejectReturnDialogContentProps) {
  const t = useTranslation();
  const currentReturnRequest = useCurrentReturnRequest();
  const { data: shop } = useCurrentShopSuspense();
  const invalidateReturnRequest = useInvalidateReturnRequest();

  const handleClose = () => {
    setLoading(true);
    setOpen(false);
  }

  const onSuccessRejectReturnRequest = () => {
    setLoading(false);
    setTimeout(
      () =>
        invalidateReturnRequest({
          returnRequestId: currentReturnRequest.id,
          shopId: shop.id,
        }),
      500,
    );
  };
  const onSubmit = useSumbitRejectReturnRequest({
    onSuccess: onSuccessRejectReturnRequest,
    onMutate: handleClose,
    onError: () => setLoading(false),
  });
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-3xl overflow-y-scroll max-h-[calc(100vh-64px)] flex flex-col pb-0">
        <DialogHeader>
          <DialogTitle>{t("returnDetail.rejected")} </DialogTitle>
        </DialogHeader>
        <Separator className="mt-1 mb-0 pb-0" />
        <RejectForm onSubmit={onSubmit} handleClose={handleClose} />
      </DialogContent>
    </Dialog>
  );
}
